import { useFormContext } from 'react-hook-form';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { ShuffleIcon } from '@/icons';
import { useAvatarCatalog } from '@/shared/features/user-avatar';
import { Button } from '@/ui_v3';
import { pickRandomPartId } from '../avatarDecorate.logic';
import { type AvatarDecorateForm } from '../schema';
export const RandomAvatarButton = () => {
  const {
    setValue,
    getValues
  } = useFormContext<AvatarDecorateForm>();
  const {
    t
  } = useTranslation('common');
  const {
    data: catalog
  } = useAvatarCatalog('quiz');
  const randomize = () => {
    if (!catalog) return;
    setValue('avatar', {
      ...getValues('avatar'),
      skinId: pickRandomPartId(catalog.shapes.skin ?? []),
      hairId: pickRandomPartId(catalog.shapes.hair ?? []),
      faceId: pickRandomPartId(catalog.shapes.face ?? []),
      clothesId: pickRandomPartId(catalog.shapes.clothes ?? [])
    }, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true
    });
  };
  return <Button variant="contained" intent="neutral" size="sm" leftSlot={<ShuffleIcon size="xs" color={ICON_COLOR.neutral} />} onClick={randomize} data-sentry-element="Button" data-sentry-component="RandomAvatarButton" data-sentry-source-file="RandomAvatarButton.tsx">
      {t('avatarDecorate.random')}
    </Button>;
};